module.exports = __webpack_public_path__ + "img/career-banner.ff4cc8af.jpg";